var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hub-slider__container"},[_c('v-slider',_vm._b({attrs:{"hide-details":""},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}},'v-slider',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }